import { ENUM_CARD_TYPE } from '../../enums/card-type.enum';
export const findEmptyCardIndex = (cards) => {
    return cards.findIndex((card) => {
        var _a, _b, _c;
        if (card.type === ENUM_CARD_TYPE.LINK) {
            return !((_a = card.link_details) === null || _a === void 0 ? void 0 : _a.url);
        }
        if (card.type === ENUM_CARD_TYPE.POST) {
            return !((_b = card.post_details) === null || _b === void 0 ? void 0 : _b.url);
        }
        if (card.type === ENUM_CARD_TYPE.EMBED) {
            return !((_c = card.embed_details) === null || _c === void 0 ? void 0 : _c.html);
        }
        return false;
    });
};
export const updateCardAtIndex = (cards, index, payload) => {
    return cards.map((card, i) => (i === index ? Object.assign(Object.assign({}, card), payload) : card));
};
export const getNewCardPosition = (cards) => {
    if (cards.length === 0)
        return 0;
    return Math.max(...cards.map((card) => { var _a; return (_a = card.position) !== null && _a !== void 0 ? _a : 0; })) + 1;
};
//# sourceMappingURL=card-reducer-helpers.js.map